export const deviceArr = [
    {
        bridgeName: "白沙大桥-静力水准仪-ND-00",
        longitude: "119.278708342349",
        latitude: "29.4706975647260",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-01",
        longitude: "119.278905488786",
        latitude: "29.4719317301221",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-02",
        longitude: "119.278888087913",
        latitude: "29.4718117839997",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-03",
        longitude: "119.278871899392",
        latitude: "29.4717196258714",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-04",
        longitude: "119.278837342085",
        latitude: "29.4714984225615",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-05",
        longitude: "119.278819844293",
        latitude: "29.4713931107444",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-06",
        longitude: "119.278802993084",
        latitude: "29.4712877462062",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-07",
        longitude: "119.278766699033",
        latitude: "29.4710613504295",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-08",
        longitude: "119.278745490574",
        latitude: "29.4709287439988",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥-静力水准仪-ND-09",
        longitude: "119.278726853455",
        latitude: "29.4708142750542",
        height: "44.912",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "白沙大桥GNSS-01",
        longitude: "119.278855029073",
        latitude: "29.4716089774915",
        height: "35.025",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "白沙大桥GNSS-02",
        longitude: "119.278785120438",
        latitude: "29.4711776504135",
        height: "35.025",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "白沙大桥GNSS-03",
        longitude: "119.278707444824",
        latitude: "29.4706948029881",
        height: "35.025",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "新安江大桥-温湿度-WSD-01",
        longitude: "119.265730155947",
        latitude: "29.4703228669444",
        height: "44.41",
        image: require('@/assets/image/device-type/WSD.png'),
    },
    {
        bridgeName: "新安江大桥-静力水准仪-ND-00",
        longitude: "119.265784019675",
        latitude: "29.4703071392037",
        height: "43.909",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "新安江大桥-静力水准仪-ND-01",
        longitude: "119.265882878040",
        latitude: "29.4706353671325",
        height: "43.909",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "新安江大桥-静力水准仪-ND-02",
        longitude: "119.266119348483",
        latitude: "29.4714225648981",
        height: "43.909",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "新安江大桥-静力水准仪-ND-03",
        longitude: "119.266167390236",
        latitude: "29.4715836846051",
        height: "43.909",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "新安江大桥-静力水准仪-ND-04",
        longitude: "119.266217819235",
        latitude: "29.4717514188346",
        height: "43.909",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "新安江大桥-静力水准仪-ND-05",
        longitude: "119.266451261324",
        latitude: "29.4725289416927",
        height: "43.909",
        image: require('@/assets/image/device-type/ND.png'),
    },
    {
        bridgeName: "新安江大桥GNSS-01",
        longitude: "119.266576769416",
        latitude: "29.4729475443214",
        height: "34",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "新安江大桥GNSS-02",
        longitude: "119.266332296259",
        latitude: "29.4721318260004",
        height: "34",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "新安江大桥GNSS-03",
        longitude: "119.266152422913",
        latitude: "29.4715316244061",
        height: "62.671",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "新安江大桥GNSS-04",
        longitude: "119.266006536604",
        latitude: "29.4710461316018",
        height: "34",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "新安江大桥GNSS-05",
        longitude: "119.265771383157",
        latitude: "29.4702621372649",
        height: "34",
        image: require('@/assets/image/device-type/GNSS.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-01",
        longitude: "119.266508165081",
        latitude: "29.4729189910380",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-02",
        longitude: "119.266621303874",
        latitude: "29.4728939914303",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-03",
        longitude: "119.266487386976",
        latitude: "29.4726510191920",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-04",
        longitude: "119.266395914430",
        latitude: "29.4725443900578",
        height: "53.808",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-05",
        longitude: "119.266456542717",
        latitude: "29.4725306443559",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-06",
        longitude: "119.266507117922",
        latitude: "29.4725200047379",
        height: "53.808",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-07",
        longitude: "119.266413198723",
        latitude: "29.4724027215107",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-08",
        longitude: "119.266272536242",
        latitude: "29.4721463713351",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-09",
        longitude: "119.266392264258",
        latitude: "29.4721204218977",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-10",
        longitude: "119.266218562899",
        latitude: "29.4717525960763",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-11",
        longitude: "119.266115103065",
        latitude: "29.4716004007964",
        height: "62.5",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-12",
        longitude: "119.266168101251",
        latitude: "29.4715849693651",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-13",
        longitude: "119.266222749638",
        latitude: "29.4715767113114",
        height: "62.5",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-14",
        longitude: "119.266118974437",
        latitude: "29.4714222682447",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-15",
        longitude: "119.265950405991",
        latitude: "29.4710604790050",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-16",
        longitude: "119.266058390145",
        latitude: "29.4710358620510",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-17",
        longitude: "119.265926731961",
        latitude: "29.4707795964892",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-18",
        longitude: "119.265836896320",
        latitude: "29.4706702180125",
        height: "53.82",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-19",
        longitude: "119.265890326027",
        latitude: "29.4706602496010",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-20",
        longitude: "119.265943313205",
        latitude: "29.4706468613449",
        height: "53.82",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-21",
        longitude: "119.265849845214",
        latitude: "29.4705247369853",
        height: "43.909",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-22",
        longitude: "119.265733972495",
        latitude: "29.4702733839394",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "新安江大桥-表面应变计-YB-23",
        longitude: "119.265812641395",
        latitude: "29.4702543601186",
        height: "34",
        image: require('@/assets/image/device-type/YB.png'),
    },
    {
        bridgeName: "振动加速度计-ZD-01",
        longitude: "119.266413198723",
        latitude: "29.4724027215107",
        height: "43.909",
        image: require('@/assets/image/device-type/ZD.png'),
    },
    {
        bridgeName: "振动加速度计-ZD-02",
        longitude: "119.266218562899",
        latitude: "29.4717525960763",
        height: "43.909",
        image: require('@/assets/image/device-type/ZD.png'),
    },
    {
        bridgeName: "振动加速度计-ZD-03",
        longitude: "119.266168101251",
        latitude: "29.4715849693651",
        height: "43.909",
        image: require('@/assets/image/device-type/ZD.png'),
    },
    {
        bridgeName: "振动加速度计-ZD-04",
        longitude: "119.266118974437",
        latitude: "29.4714222682447",
        height: "43.909",
        image: require('@/assets/image/device-type/ZD.png'),
    },
    {
        bridgeName: "振动加速度计-ZD-05",
        longitude: "119.265926731961",
        latitude: "29.4707795964892",
        height: "43.909",
        image: require('@/assets/image/device-type/ZD.png'),
    },
    {
        bridgeName: "索力加速度计-SL-01",
        longitude: "119.266215510879",
        latitude: "29.4715479367637",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-02",
        longitude: "119.266103790131",
        latitude: "29.4715720441165",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-03",
        longitude: "119.266149397025",
        latitude: "29.4713272817981",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-04",
        longitude: "119.266037718559",
        latitude: "29.4713519113304",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-05",
        longitude: "119.265970494407",
        latitude: "29.4707312247502",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-06",
        longitude: "119.265858785900",
        latitude: "29.4707552004288",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-07",
        longitude: "119.265937374750",
        latitude: "29.4706207070604",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-08",
        longitude: "119.265825705208",
        latitude: "29.4706452521769",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-09",
        longitude: "119.265920844161",
        latitude: "29.4705657390001",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "索力加速度计-SL-10",
        longitude: "119.265809186303",
        latitude: "29.4705901709932",
        height: "49.712",
        image: require('@/assets/image/device-type/SL.png'),
    },
    {
        bridgeName: "白沙大桥-温湿度-WSD-01",
        longitude: "119.278909342137",
        latitude: "29.4722800029295",
        height: "44.716",
        image: require('@/assets/image/device-type/WSD.png'),
    },
];
